import { Dayjs } from "dayjs"
import { IReferralCode } from "./referralCode.types"
import { getReferralCodeFromCustomerNumber } from "@/helpers/referralHelper"

export class ReferralCode implements IReferralCode {
  constructor(
    public customerNumber: string,
    public accountNumber: string,
    public userId: number,
    public email: string,
    public lastUsedDate?: Dayjs,
  ) {}

  get code() {
    return getReferralCodeFromCustomerNumber(this.customerNumber)
  }
}
